import React$1 from 'react';

const DownSmall = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M6.5 11.864L.136 5.5 1.55 4.086l4.95 4.95 4.95-4.95L12.864 5.5z"
}));

export default DownSmall;
